export const BUILD_VERSION = '1784898248';
